<div class="ai-citations-wrapper">
  <!-- Top header (same pattern as Prompt Tracking / Prompt Creation: title + actions + mobile tab menu) -->
  <div class="active-tab-info">
    <div class="tab-menu-wrapper">
      <h2>AI Citations</h2>
      <button class="mobile-tab-menu-button" mat-icon-button [matMenuTriggerFor]="tabMenu" matTooltip="Open tab menu">
        <mat-icon>menu</mat-icon>
      </button>  
    </div>

    <div class="header-actions">
      @if (showPlatformFilter) {
        <mat-form-field appearance="outline" class="platform-filter-field header-filter platform-selector-wrap"
                        matTooltip="All platforms by default; narrow to one or more platforms" matTooltipPosition="below">
          <mat-select [value]="platformFilterMatSelectValue" (selectionChange)="onPlatformFilterChange($event.value)" multiple
                      placeholder="Filter by Platform" panelClass="platform-filter-panel">
            <mat-select-trigger>
              <span class="platform-label">{{ getPlatformFilterDisplayLabel() }}</span>
            </mat-select-trigger>
            @for (opt of platformFilterOptions; track opt.id) {
              <mat-option [value]="opt.id">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (simpleSourceTableData.length > 0) {
        <button mat-button (click)="exportSourcesTableCSV()" class="export-btn">
          <mat-icon>file_download</mat-icon>
          Export sources
        </button>
      }
      @if (simpleCitedPagesTableData.length > 0 && isPlatformFilterValid) {
        <button mat-button (click)="exportCitedPagesTableCSV()" class="export-btn">
          <mat-icon>file_download</mat-icon>
          Export cited pages
        </button>
      }
    </div>
    <!-- <div class="mobile-tab-menu-wrapper">
      <button mat-icon-button [matMenuTriggerFor]="tabMenu" matTooltip="Open tab menu" class="mobile-tab-menu">
        <mat-icon>menu</mat-icon>
      </button>
    </div> -->
  </div>

  <!-- Tab selection menu (mobile) -->
  <mat-menu #tabMenu="matMenu">
    @for (tab of getVisibleTabs(); track tab.id) {
      @if (tab.subTabs && tab.subTabs.length > 0) {
        <button mat-menu-item [matMenuTriggerFor]="auditSubMenu">
          <mat-icon>{{ tab.icon }}</mat-icon>
          <span>{{ tab.name }}</span>
          <mat-icon>arrow_right</mat-icon>
        </button>
      } @else {
        <button mat-menu-item (click)="openTab(tab.id)">
          <mat-icon>{{ tab.icon }}</mat-icon>
          <span>{{ tab.name }}</span>
        </button>
      }
    }
  </mat-menu>
  <mat-menu #auditSubMenu="matMenu">
    @for (subTab of getSubTabs('audit'); track subTab.id) {
      <button mat-menu-item (click)="openSubTab('audit', subTab.id)">
        <mat-icon>{{ subTab.icon }}</mat-icon>
        <span>{{ subTab.name }}</span>
      </button>
    }
  </mat-menu>

  @if (aiCitationsResponse) {
  <div class="ai-citations-container">
  @if (aiCitationsView === 'main') {
  <!-- <div class="top-row">
    <div class="left-column">
      <app-composite-score-widget [compositeScore]="compositeScore" [title]="'AI Citations Score'" [size]="'medium'">
      </app-composite-score-widget>

      <div class="ai-visibility-section">
        <app-generic-ai-visibility
          [llmComparisonData]="llmComparisonData"
          [llmComparisonMetricsProgress]="llmComparisonMetricsProgress"
          [isLLMComparisonMetricsLoading]="isLLMComparisonMetricsLoading"
          [llmComparisonMetricsTaskId]="llmComparisonMetricsTaskId"
          [showReloadProgress]="showProgressBelowLoader"
          (filterChange)="onCitedPagesFilterChange($event)"
          (cancelTask)="onCancelLLMComparisonMetrics($event)"
          (reloadMetrics)="onReloadLLMComparisonMetrics()">
        </app-generic-ai-visibility>
      </div>
    </div>

    <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">AI Citations Index</h4>
          <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
        </div>
      </div>

      <div class="chart-mobile-wrapper" #chartContainer>
        @if(shouldRenderChart && (results.length > 0 || lineChart.length > 0)) {
        <div class="combo-chart-wrapper">
          <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [colorSchemeLine]="lineChartScheme"
            [results]="results" [lineChart]="lineChart" [barBrandName]="firstBrandName || 'Your Brand'"
            [animations]="true" [tooltipDisabled]="false" [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale" [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat" [gradient]="false" [xAxis]="true" [yAxis]="true"
            [legend]="true" [legendTitle]="'Brands'" [legendPosition]="'right'" [showGridLines]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [showRightYAxisLabel]="true"
            [xAxisLabel]="'AI Citations Metrics'" [yAxisLabel]="'Score'" [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true" [wrapTicks]="false" (select)="onSelect($event)" (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
        } @else if (!shouldRenderChart) {
        <div class="chart-placeholder">
          <p>Chart will load when tab becomes visible...</p>
        </div>
        }
        @if(tableRows.length > 0) {
        <app-common-performance-table [rows]="tableRows" [columns]="tableColumns" [title]="'AI Citations Performance'">
        </app-common-performance-table>
        }
      </div>
    </div>
  </div>

  @if(recommendedDomainsData.length > 0) {
  <div class="recommended-domains-section">
    <app-common-simple-table 
      [data]="recommendedDomainsData" 
      [columns]="recommendedDomainsColumns" 
      [config]="recommendedDomainsConfig"
      title="Recommended Domains" 
      subtitle="Industry-relevant domains recommended for your sector (LLM + Tavily generated)">
    </app-common-simple-table>
  </div>
  }

  @if (false && citedPagesData.length > 0) {
  <div class="cited-pages-section">
    <div class="cited-pages-header">
      <div class="header-left">
        <h3>Cited Pages</h3>
        <p class="subtitle">
          Specific web pages cited by AI tools (ChatGPT, Perplexity, Gemini, Claude)
        </p>
        <p class="date-range-info">
          <mat-icon>calendar_today</mat-icon>
          Showing data from 
          <strong>{{ smartDateRange.start | date:'dd MMM yyyy' }}</strong> 
          to 
          <strong>{{ smartDateRange.end | date:'dd MMM yyyy' }}</strong>
        </p>
      </div>
      <div class="header-right">
        <button mat-button (click)="exportCitedPages()" class="export-button" [disabled]="!isPlatformFilterValid">
          <mat-icon>download</mat-icon>
          Export
        </button>
      </div>
    </div>

    <div class="cited-pages-filters">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>LLM Source</mat-label>
        <mat-select [value]="citedPagesFilters.selectedLLMSources" 
                    (selectionChange)="onLLMSourceFilterChange($event.value)" 
                    multiple>
          @for(source of availableLLMSources; track source) {
          <mat-option [value]="source">{{ source }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Domain</mat-label>
        <mat-select [value]="citedPagesFilters.selectedDomains" 
                    (selectionChange)="onDomainFilterChange($event.value)" 
                    multiple>
          @for(domain of availableDomains; track domain) {
          <mat-option [value]="domain">{{ domain }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if(citedPagesFilters.selectedLLMSources.length > 0 || citedPagesFilters.selectedDomains.length > 0) {
      <button mat-button (click)="clearCitedPagesFilters()" 
              class="clear-filters-button">
        Clear Filters
      </button>
      }
    </div>

    <div class="results-count">
      <strong>{{ citedPagesData.length }}</strong> results
    </div>

    <app-common-simple-table 
      [data]="citedPagesData" 
      [columns]="citedPagesColumns" 
      [config]="citedPagesConfig"
      title="" 
      subtitle="">
    </app-common-simple-table>
  </div>
  } @else if(hasHistoryData === false && aiCitationsResponse) {
  <div class="no-data-message">
    <mat-icon>info</mat-icon>
    @if(isOldCachedResponse) {
    <p>This is a cached response from before the new features were added.</p>
    <p class="hint">Please run a new analysis to see recommended domains and cited pages data.</p>
    } @else {
    <p>No cited pages data found in the selected date range.</p>
    <p class="hint">Try selecting a different date range or run a new analysis.</p>
    }
  </div>
  }

  <!-- HIDDEN: Sources & Citations (do not remove)
  @if (getCitations().length > 0) {
  <app-citation-card [citations]="getCitations()" [title]="'Sources & Citations'" [displayStyle]="'grid'"
    [maxDisplay]="6">
  </app-citation-card>
  }

  
  @if(metadata) {
  <div class="metadata-section">
    <h3>Analysis Details</h3>
    <div class="metadata-content">
      <div class="metadata-grid">
        <div class="metadata-item">
          <strong>Industry:</strong> {{ metadata.industry }}
        </div>
        <div class="metadata-item">
          <strong>Your Brand:</strong> {{ metadata.your_brand }}
        </div>
        <div class="metadata-item">
          <strong>Competitors:</strong> {{ metadata.competitors?.join(', ') }}
        </div>
        <div class="metadata-item">
          <strong>Brands Analyzed:</strong> {{ metadata.brands_analyzed }}
        </div>
        <div class="metadata-item">
          <strong>Data Source:</strong> {{ metadata.data_source }}
        </div>
        <div class="metadata-item">
          <strong>Response Time:</strong> {{ metadata.response_time | number:'1.2-2' }}s
        </div>
      </div>
    </div>
  </div>
  } -->

  <!-- AI Cited domains and pages (below all existing data) – charts and tables from llm_comparison JSON; hidden when no data -->
  @if (hasSimpleAiCitedData) {
  <div class="simple-ai-cited-section">
    <div class="simple-ai-cited-header-row">
      <div>
        <h3 class="simple-ai-cited-title">AI Cited domains and pages</h3>
        <p class="simple-ai-cited-subtitle">Source usage by domain, domain type breakdown, and cited pages from AI visibility metrics (screenshot-style data only).</p>
      </div>
    </div>

    <div class="simple-ai-cited-charts-row">
      @if(simpleSourceUsageLineChartData.length > 0) {
      <div class="simple-ai-cited-chart source-usage">
        <h4>Source Usage by Domain</h4>
        <app-bar-chart [groupedBarData]="simpleSourceUsageLineChartData" [xAxisLabel]="'Date'" [yAxisLabel]="'Percent used'" chartType="line" [showDomainLegend]="true">
        </app-bar-chart>
      </div>
      }
      @if(simpleDomainTypeDonutData.length > 0) {
      <div class="simple-ai-cited-chart domain-type-donut">
        <h4>Domain type</h4>
        <div class="donut-wrapper">
          <app-pie-chart [results]="simpleDomainTypeDonutData" [doughnut]="true" [legend]="true" [showLabels]="false" [animations]="false">
          </app-pie-chart>
          @if(simpleDomainTypeDonutTotal > 0) {
          <div class="donut-center">
            <span class="donut-center-value">{{ simpleDomainTypeDonutTotal | number }}</span>
            <span class="donut-center-label">Citations</span>
          </div>
          }
        </div>
      </div>
      }
    </div>

    @if(simpleSourceUsageLineChartData.length === 0 && simplePlatformMentionsChartData.length > 0) {
    <div class="simple-ai-cited-chart">
      <h4>Mentions by platform</h4>
      <app-bar-chart [groupedBarData]="simplePlatformMentionsChartData" [xAxisLabel]="'Platform'" [yAxisLabel]="'Mentions'" chartType="line">
      </app-bar-chart>
    </div>
    }

    @if(simpleSourceTableData.length > 0 && !selectedDomainForPages) {
    <div class="simple-ai-cited-table" id="ai-citations-sources-by-domain">
      <div class="sources-by-domain-header">
        <h4>Sources by domain</h4>
        <button mat-button (click)="exportSourcesTableCSV()" [disabled]="simpleSourceTableData.length === 0 || !isPlatformFilterValid" matTooltip="Export to CSV">
          <mat-icon>download</mat-icon> Export CSV
        </button>
      </div>
      <p class="table-hint">Click a row to see sites for that domain.</p>
      <app-common-simple-table
        [data]="simpleSourceTableData"
        [columns]="simpleSourceTableColumns"
        [config]="simpleSourceTableConfig"
        title=""
        subtitle=""
        (rowClick)="onSimpleSourceRowClick($event)">
      </app-common-simple-table>
    </div>
    }

    @if(selectedDomainForPages) {
    <div class="simple-ai-cited-table sites-for-domain">
      <div class="cited-pages-filter-bar">
        <div class="sites-domain-left">
          <button mat-button (click)="clearSelectedDomainForPages()" class="back-to-all-btn">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
          <h4>Sites for {{ selectedDomainForPages }}</h4>
        </div>
        <button mat-button (click)="exportCitedPagesForSelectedDomainCSV()" [disabled]="citedPagesForSelectedDomain.length === 0 || !isPlatformFilterValid" matTooltip="Export sites for this domain to CSV">
          <mat-icon>download</mat-icon> Export CSV
        </button>
      </div>
      @if (citedPagesForSelectedDomain.length > 0) {
      <app-common-simple-table
        [data]="citedPagesForSelectedDomain"
        [columns]="simpleCitedPagesTableColumns"
        [config]="simpleCitedPagesTableConfig"
        title=""
        subtitle="">
      </app-common-simple-table>
      } @else {
      <p class="no-pages-message">No cited pages for this domain with the current platform filter.</p>
      }
    </div>
    }
  </div>
  }
  }
</div>
}
</div>
